import React, { useState } from "react"
import './signup.css';
import { Formik,Field,ErrorMessage } from 'formik';
import axios from 'axios';
import * as Yup from "yup"
import { useNavigate } from "react-router-dom";
import { SignUpModalSucess } from '../components/signup/SignUpModalSucess';
import { SignUpModalFaild } from '../components/signup/SignUpModalFaild';


export default function Signup()
{
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  let navigate = useNavigate();

  const [error,setErorr]=useState('')
  const schema=()=>{
    const schema =Yup.object().shape({
      name:Yup.string().required("Full Name is requierd"),
      username:Yup.string().required("Username is requierd"),
      email:Yup.string().required("Email is requierd").email('Email must be a valid '),
      password:Yup.string().required("Password is requierd")     .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
      )   ,
      confarmPassword:Yup.string().required("Confirm password is requierd")    .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
      ) .oneOf([Yup.ref('password'), null], 'Passwords must match')  ,

    })
    return schema
  }

  const openModal = () => {
    setShowModal(prev => !prev);
  };
  const openModal2 = () => {
    setShowModal2(prev => !prev);
  };
return(

<div  style={{ 
      backgroundImage: `url("./assets/png/Coming-soon-Main.png")` 
    }} className="bg h-100" >

<SignUpModalSucess showModal={showModal} setShowModal={setShowModal} />
<SignUpModalFaild showModal={showModal2} setShowModal={setShowModal2} />


      <div style={{width:'100%',height:'57px'}}>

      </div>
      <div className="sticky">
        <a href="#">
        <img src="./assets/png/YT.png" alt="Logo"/>

        </a>

      </div>
	<div className="modal-dialog modal-login ">
		<div className="modal-content">
			<div className="modal-header">
        <div >
        <img src="./assets/png/Logo.png" alt="Logo" className="avatar"/>

        </div>
			
				<h2 className="modal-title header-text">Sign up to Legaci</h2>	

			</div>
            <p className="modal-title text-center">Start your journy with our product</p>	

			<div className="modal-body">

            <Formik
       initialValues={{name:'',username:'', email: '', password: '' , confarmPassword: ''}}
    
       validationSchema={schema()}
       onSubmit={async (values, { setSubmitting }) => {
      await  axios.post('http://159.203.51.106:3000/v1/guest/user', {
          fullname:values.name,
          username:values.username,
          password:values.password,
          email:values.email
        })
        .then(function (response) {

          setErorr('')
          setSubmitting(false);
          openModal()

          setTimeout(() => {

            navigate("/");

          }, 2000);


        })
        .catch(function (error) {
          if(error.response.data.message=="Oops! you are already registered!"){
            openModal2()
            setErorr("Email or Username already used")
          }
        });
       }}
     >
       {({
         values,
         handleChange,
         handleBlur,
         handleSubmit,
         isSubmitting,
         /* and other goodies */
       }) => (
         <form onSubmit={handleSubmit}>


<label  className="form-label mt-1">Full Name</label>

     

           <Field name="name" className="form-control" placeholder="Full Name"     onChange={handleChange}
             onBlur={handleBlur}
             required="required"

             value={values.name}/>
           <p className="text-danger mt-1">
           <ErrorMessage className="text-danger" name="name"/>

           </p>

<label  className="form-label mt-1">Username</label>

<Field name="username" className="form-control" placeholder="Username" 
    onChange={handleChange}
             onBlur={handleBlur}
             required="required"

             value={values.username}/>
           <p className="text-danger mt-1">
           <ErrorMessage className="text-danger" name="username"/>

           </p>

     

<label  className="form-label mt-1">Email</label>
<Field              type="email"
 name="email" className="form-control" placeholder="Email" 
 required="required"

    onChange={handleChange}
             onBlur={handleBlur}
             value={values.email}/>
           <p className="text-danger mt-1">
           <ErrorMessage className="text-danger" name="email"/>

           </p>
<p className="text-danger mt-1">{error}</p>
           <label  className="form-label mt-1">Password</label>

           <Field              type="password"
 name="password" className="form-control" placeholder="Password" 
 required="required"

    onChange={handleChange}
             onBlur={handleBlur}
             value={values.password}/>
           <p className="text-danger mt-1">
           <ErrorMessage className="text-danger" name="password"/>
           </p>


           <label  className="form-label mt-1">Confirm Password</label>


<Field  type="password"
 name="confarmPassword" className="form-control" placeholder="Confarm Password" 
 required="required"

    onChange={handleChange}
             onBlur={handleBlur}
             value={values.confarmPassword}/>
           <p className="text-danger mt-1">
           <ErrorMessage  name="confarmPassword"/>

           </p>


           <button type="submit" disabled={isSubmitting} className="btn btn-primary btn-lg btn-block login-btn mt-4">
             Sign up
           </button>
         </form>
       )}
     </Formik>
		
			</div>
	
		</div>
	</div>

</div>

)
}